// extracted by mini-css-extract-plugin
export default {"container":"container-AGjM4n","back":"back-i3ixOP","icon":"icon-rbOFcA","active":"active-LIxJ58","text":"text-D4C183"};